export default function (instance) {
  return {
    getAll(userId, config = {}) {
      return instance.get(`users/${userId}/products`, config);
    },
  };
}
